/* globals $ */
'use strict';

$(function () {
  // Scroll-into-view animation
  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('in-view');

        obs.unobserve(entry.target);
      }
    });
  });
  document.querySelectorAll('.appear-container').forEach((el) => {
    observer.observe(el);
  });

  let textSizeCanvas = document.createElement('canvas');
  let textSizeContext = textSizeCanvas.getContext('2d');
  function getTextWidth(text, font) {
    textSizeContext.font = font;
    let metrics = textSizeContext.measureText(text);
    return metrics.width;
  }
  const fontProps = [
    'font-style',
    'font-variant',
    'font-weight',
    'font-size',
    'font-family',
  ];
  $('.bus-contact .text-field').on('input', function () {
    $(this)
      .removeClass('empty not-empty')
      .addClass($(this).val() ? 'not-empty' : 'empty');
    let cs = window.getComputedStyle(this, null);
    let font = [];
    for (let fp of fontProps) {
      font.push(cs.getPropertyValue(fp));
    }
    let w = getTextWidth($(this).val(), font.join(' '));
    $(this)
      .nextAll('.text-progress:eq(0)')
      .find('span')
      .css('width', w + 'px');
  });
  $('.bus-contact .text-field').trigger('input');

  let form = $('.bus-contact form');
  form.on('submit', function (e) {
    let data = form.serializeArray();
    $.post('/foretag/kontakt', data)
      .done(function (data) {
        console.log('data /foretag/kontakt', data);
        if (data.error || data.status === 'error') {
          form.addClass('error');
          form.removeClass('submitted');
        }
      })
      .fail(function (error) {
        console.error('error post to /foretag/kontakt', error);
        form.addClass('error');
        form.removeClass('submitted');
      });
    form.addClass('submitted');
    e.preventDefault();
  });
});
